import { mapMutationsFromTypes } from 'schepotin-vuex-helpers';
import * as types from './mutation-types';

export default {
    /**
     * Generates {@link https://vuex.vuejs.org/en/mutations.html | mutations} from
     * {@link https://vuex.vuejs.org/en/mutations.html#using-constants-for-mutation-types | mutation types}
     *
     * Documentation
     * {@link https://www.npmjs.com/package/schepotin-vuex-helpers#mapmutationsfromtypes | mapMutationsFromTypes}
     */
    ...mapMutationsFromTypes({
        types,
        excludes: [
            types.SCHOOL_CLEAR_INFO,
            types.SCHOOL_FILL_INFO,
            types.SCHOOL_FILL_COURSES,
        ],
    }),

    [types.SCHOOL_CLEAR_INFO](state) {
        state.id = null;
        state.title = null;
        state.address = null;
        state.serial = null;
        state.subStartDate = null;
        state.subPeriod = null;
        state.studentLicences = null;
        state.teacherLicences = null;
        state.country = {
            id: 0,
            title: null,
        };
        state.createdAt = null;
        state.courses = [];
    },

    [types.SCHOOL_FILL_INFO](state, payload) {
        state.id = payload.id;
        state.title = payload.title;
        state.address = payload.address;
        state.serial = payload.serial;
        state.subStartDate = payload.sub_start_date;
        state.subPeriod = payload.sub_period;
        state.studentLicences = payload.student_licences;
        state.teacherLicences = payload.teacher_licences;
        state.defaultLanguage = {
            language: payload.default_language || 'en',
            direction: payload.default_direction || 'ltr',
        };
        state.country = {
            id: payload.country.id,
            title: payload.country.title,
        };
        state.createdAt = payload.created_at;
    },

    [types.SCHOOL_FILL_COURSES](state, payload) {
        payload.forEach((item) => {
            state.courses.push({
                id: item.id,
                title: item.name_translation[0].translation,
            })
        });
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/school/mutations.js